module.exports = __webpack_public_path__ + "img/58a4030.png";